import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";
import { Textarea } from "../../../components/textarea";

//Registration schema
const schema = yup.object().shape({
    subjectTitle: yup.string().required("Subject Title is a required field"),
    subjectMessage: yup.string().required("Subject Message is a required field"),
    receiver: yup.string().required("Receiver is a required field"),
    school: yup.string().required("School is a required field"),
    priority: yup.string().required("Priority is a required field"),
});

const AdminSupportMakeAnnouncement = () => {
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];

    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        control,
        formState: { errors },
        register,
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Extra/Support
                        </Heading>
                        <Breadcrumb
                            crumbs={['support', 'MAKE ANNOUNCEMENT']}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="subjectTitle"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="subjectTitle"
                                                type="text"
                                                label="TITLE"
                                                placeholder="Subject Title"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.subjectTitle?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Textarea
                                    id="subjectMessage"
                                    type="text"
                                    label="MESSAGE"
                                    placeholder="Subject Message"
                                    {...register("subjectMessage")}
                                    error={errors.subjectMessage?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Controller
                                    control={control}
                                    name="receiver"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="receiver"
                                                type="text"
                                                label='SEND TO'
                                                placeholder="Select Type"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.receiver?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="school"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="school"
                                                type="text"
                                                label='CHOOSE SCHOOL'
                                                placeholder="Select School"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.school?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="priority"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="priority"
                                                type="text"
                                                label='priority'
                                                placeholder="Select Priority Level"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.priority?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                SUBMIT
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AdminSupportMakeAnnouncement
